
import Component from '../../../assets/scripts/modules/component'

export default class SkipToMainComponent extends Component {
  async init () {
    this.link = this.element.querySelector('.link')

    if (!this.link) {
      return
    }

    this.link.addEventListener('click', event => this.clickHandler(event))
  }

  update () {
    //
  }

  destroy () {
    //
  }

  clickHandler (event) {
    const href = (this.link.getAttribute('href') || '#').split('#')[1]

    if (!href) {
      return
    }

    const target = document.getElementById(href)

    if (!target) {
      return
    }

    const rect = target.getBoundingClientRect()
    const top = window.pageYOffset + rect.top

    window.scroll({ top: top - 40, left: 0, behavior: 'smooth' })

    if (event) {
      // event.preventDefault()
      // event.stopPropagation()
    }

    window.requestAnimationFrame(() => this.link.blur())
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.skip-to-main')) {
    element.instance = element.instance || new SkipToMainComponent(element)
  }
})
